import React from 'react';
import { Modal, Box, SpaceBetween, Button } from '@cloudscape-design/components';
import { formatDateTime } from 'src/utils/generalUtils';

interface ChangeDueDateModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  originalDate: string;
  newDate: string;
}

export const ChangeDueDateModal: React.FC<ChangeDueDateModalProps> = ({
  visible,
  onDismiss,
  onConfirm,
  originalDate,
  newDate,
}) => {
  const formatDate = (dateString: string) => {
    try {
      return formatDateTime(dateString, 'DD MMM YYYY');
    } catch {
      return dateString;
    }
  };

  return (
    <Modal
      onDismiss={onDismiss}
      visible={visible}
      header="Confirm Due Date Change"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              Confirm Change
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <Box>
          You are about to change the task due date from{' '}
          <strong>{formatDate(originalDate)}</strong> to{' '}
          <strong>{formatDate(newDate)}</strong>. Would you like to proceed?
        </Box>
      </SpaceBetween>
    </Modal>
  );
};
